class PdpUpsellItemQuantity extends HTMLElement {
  constructor() {
    super();
  }

  // Callback called when the element is connected to the DOM.
  connectedCallback() {
    this.section = this;
    this.quantityControlComponent = this.section.querySelector(
      "pdp-upsell-quantity-controls"
    );

    this.addEventListener(
      "pdp-upsell-quantity-control-quantity-change",
      this.quantityEventHandler
    );
  }

  // Callback called when the element is disconnected from the DOM.
  disconnectedCallback() {
    this.quantityControlComponent.removeEventListener(
      "input",
      this.quantityEventHandler
    );
  }

  /**
   * Event handler for quantity change events.
   * @param {Event} event - The quantity change event.
   */
  quantityEventHandler(event) {
    const {
      detail: { quantity },
    } = event;

    this.dispatchEvent(
      new CustomEvent("pdp-upsell-item-quantity-change", {
        bubbles: true,
        detail: {
          quantity,
        },
      })
    );
  }

  /**
   * Gets the current quantity.
   * @returns {number} The current quantity.
   */
  getQuantity() {
    return parseInt(this.quantityControlComponent.getQuantity());
  }

  /**
   * Resets the quantity value.
   */
  resetValue() {
    this.quantityControlComponent.resetValue();
  }
}
customElements.define("pdp-upsell-item-quantity", PdpUpsellItemQuantity);
